import Marquee from "react-fast-marquee";
import { Phone, Tag } from "@phosphor-icons/react";
import { VENDORS } from "@/lib/data";

export const VendorMarquee = () => {
  return (
    <section
      data-testid="vendor-marquee-section"
      className="relative py-24 md:py-32 bg-brand-sage/60 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-12 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <div className="text-xs uppercase tracking-[0.28em] font-semibold text-brand-leaf mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-brand-gold" /> Partner Marketplace
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-brand-forest leading-tight max-w-2xl">
            Local favourites,
            <span className="italic text-brand-gold"> just downstairs.</span>
          </h2>
        </div>
        <p className="md:max-w-sm text-brand-mute">
          Hand-picked vendors offering exclusive perks to Exente residents.
          Tap a card to call or save a deal.
        </p>
      </div>

      <Marquee speed={36} gradient gradientColor="#E8EBE4" gradientWidth={80} pauseOnHover>
        {[...VENDORS, ...VENDORS].map((v, i) => (
          <article
            key={i}
            data-testid={`vendor-card-${i}`}
            className="mx-4 w-[320px] md:w-[360px] shrink-0 bg-brand-ivory rounded-2xl border border-brand-sage shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500 overflow-hidden"
          >
            <div className="h-44 overflow-hidden">
              <img
                src={v.image}
                alt={v.name}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-6">
              <div className="text-[11px] uppercase tracking-[0.2em] text-brand-leaf font-semibold">
                {v.category}
              </div>
              <h3 className="font-display text-2xl text-brand-forest mt-1">{v.name}</h3>
              <div className="mt-4 flex items-center gap-2 text-brand-gold">
                <Tag size={16} weight="fill" />
                <span className="text-sm font-medium">{v.offer}</span>
              </div>
              <a
                href={`tel:${v.phone.replace(/\s/g, "")}`}
                className="mt-4 inline-flex items-center gap-2 text-sm text-brand-forest hover:text-brand-gold transition-colors"
                data-testid={`vendor-phone-${i}`}
              >
                <Phone size={14} weight="light" /> {v.phone}
              </a>
            </div>
          </article>
        ))}
      </Marquee>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-12 text-sm text-brand-mute">
        Want your business listed here?{" "}
        <a
          href="/contact"
          data-testid="vendor-cta-link"
          className="text-brand-forest font-medium underline underline-offset-4 decoration-brand-gold hover:text-brand-gold"
        >
          Apply to become a partner →
        </a>
      </div>
    </section>
  );
};
